import * as Styled from './styles';

const AppLoading = () => (
  <Styled.Container>
    <Styled.LoadingImage alt='Loading...' src='/cropwise-planting-logo.svg' />
  </Styled.Container>
);

export default AppLoading;
